<div class="row pb-3" *ngIf="noInfoType === NO_INFO_TYPE.SINGLE && loadingState === 'SUCCESS'">
  <div class="col-4">
    <img [src]="noInfoSrc" alt="no" class="flex-shrink-0">
  </div>
  <div class="col-8 align-self-center">
    <h4 class="heading-4">
      {{noInfoHeading}}
    </h4>
    <!-- <p class="paragraph pt-2">
      {{noInfoParagraph}}!
    </p> -->
  </div>
</div>
<div class="no-available text-center"
  [ngClass]="{'no-thumbnail-height': noInfoType === NO_INFO_TYPE.SINGLE_THUMBNAIL}"
  *ngIf="(noInfoType === NO_INFO_TYPE.SINGLE || noInfoType === NO_INFO_TYPE.SINGLE_THUMBNAIL) && loadingState === 'SUCCESS'">
  <img [src]="noInfoSrc" alt="info" width="60" height="60">
  <h4 class="text-white heading-4 mt-2">
    {{noInfoHeading}}
  </h4>
  <!-- <p class="paragraph text-white mt-2">
    {{noInfoParagraph}}.
  </p> -->
  <div class="mt-3" *ngIf="noInfoType === NO_INFO_TYPE.SINGLE">
    <button class="btn btn-design medium outline border bg-white" (click)="goBack()">
      {{noInfoButtonText}}
    </button>
  </div>
</div>
<div class="no-available text-center" [ngClass]="{'no-thumbnail-height': noInfoType === NO_INFO_TYPE.SINGLE_THUMBNAIL}" *ngIf="(noInfoType === NO_INFO_TYPE.SINGLE || noInfoType === NO_INFO_TYPE.SINGLE_THUMBNAIL) && loadingState === 'PENDING'">
  <img crossOrigin = 'Anonymous' src="assets/themes/images/primary-loader.gif" width="40" height="40" class="loader-image">
<div>
